var map = {
	"./3.png": 84877,
	"./arrow2.png": 66919,
	"./attack_arrow.png": 12482,
	"./attack_direction.png": 73402,
	"./attack_direction_dark.png": 25027,
	"./attack_english.png": 49369,
	"./attack_english_dark.png": 274,
	"./attack_spanish.png": 51537,
	"./attack_spanish_dark.png": 2106,
	"./backgroundWhite.png": 21289,
	"./black_body.png": 70808,
	"./black_x.png": 17938,
	"./bodyparts/1/orange.png": 13731,
	"./bodyparts/1/red.png": 30532,
	"./bodyparts/1/yellow.png": 47025,
	"./bodyparts/10/orange.png": 98341,
	"./bodyparts/10/red.png": 41894,
	"./bodyparts/10/yellow.png": 71251,
	"./bodyparts/11/orange.png": 16390,
	"./bodyparts/11/red.png": 10339,
	"./bodyparts/11/yellow.png": 8540,
	"./bodyparts/12/orange.png": 13659,
	"./bodyparts/12/red.png": 17548,
	"./bodyparts/12/yellow.png": 20393,
	"./bodyparts/13/orange.png": 27276,
	"./bodyparts/13/red.png": 85281,
	"./bodyparts/13/yellow.png": 22354,
	"./bodyparts/14/orange.png": 63393,
	"./bodyparts/14/red.png": 39018,
	"./bodyparts/14/yellow.png": 79799,
	"./bodyparts/2/orange.png": 51086,
	"./bodyparts/2/red.png": 43995,
	"./bodyparts/2/yellow.png": 76004,
	"./bodyparts/3/orange.png": 3533,
	"./bodyparts/3/red.png": 11742,
	"./bodyparts/3/yellow.png": 21915,
	"./bodyparts/4/orange.png": 16064,
	"./bodyparts/4/red.png": 26621,
	"./bodyparts/4/yellow.png": 79726,
	"./bodyparts/5/orange.png": 95855,
	"./bodyparts/5/red.png": 95432,
	"./bodyparts/5/yellow.png": 70069,
	"./bodyparts/6/orange.png": 57418,
	"./bodyparts/6/red.png": 58863,
	"./bodyparts/6/yellow.png": 97384,
	"./bodyparts/7/orange.png": 20265,
	"./bodyparts/7/red.png": 60450,
	"./bodyparts/7/yellow.png": 45439,
	"./bodyparts/8/orange.png": 35276,
	"./bodyparts/8/red.png": 68641,
	"./bodyparts/8/yellow.png": 32594,
	"./bodyparts/9/orange.png": 14747,
	"./bodyparts/9/red.png": 93676,
	"./bodyparts/9/yellow.png": 23433,
	"./bubble-size.png": 99814,
	"./cbf-logo.png": 25813,
	"./contactPageES.png": 68007,
	"./cover.png": 11963,
	"./dl.png": 26404,
	"./driblab.png": 32818,
	"./driblab_color.png": 85114,
	"./driblab_color_white.png": 72560,
	"./driblab_dark.png": 48875,
	"./driblab_fpbd.png": 35527,
	"./driblab_normal_color.png": 36270,
	"./driblab_normal_white.png": 11772,
	"./driblab_white.png": 91736,
	"./driblab_white_box_pro.png": 12898,
	"./eng-fa-logo.png": 62644,
	"./favicon.png": 90286,
	"./fb.png": 6480,
	"./front_goal.png": 21945,
	"./half_pitch_black.png": 63800,
	"./half_pitch_blue.png": 24009,
	"./half_pitch_green.png": 53440,
	"./half_pitch_grey.png": 76296,
	"./half_pitch_white.png": 74658,
	"./insta.png": 65979,
	"./legend.png": 92063,
	"./legend_dark.png": 8904,
	"./legend_english.png": 82550,
	"./legend_english_dark.png": 17783,
	"./legend_spanish.png": 5894,
	"./legend_spanish_dark.png": 7463,
	"./legend_xa.png": 5137,
	"./legend_xa_dark.png": 23610,
	"./legend_xa_dark_vertical.png": 81561,
	"./legend_xa_english.png": 4707,
	"./legend_xa_english_dark.png": 24729,
	"./legend_xa_english_dark_vertical.png": 78996,
	"./legend_xa_english_vertical.png": 26979,
	"./legend_xa_spanish.png": 53680,
	"./legend_xa_spanish_dark.png": 3865,
	"./legend_xa_spanish_dark_vertical.png": 95892,
	"./legend_xa_spanish_vertical.png": 94819,
	"./legend_xa_vertical.png": 28844,
	"./legend_xg.png": 74535,
	"./legend_xg_dark.png": 54208,
	"./legend_xg_dark_vertical.png": 84723,
	"./legend_xg_english.png": 90862,
	"./legend_xg_english_dark.png": 58015,
	"./legend_xg_english_dark_vertical.png": 36038,
	"./legend_xg_english_vertical.png": 61549,
	"./legend_xg_spanish.png": 9550,
	"./legend_xg_spanish_dark.png": 74495,
	"./legend_xg_spanish_dark_vertical.png": 14054,
	"./legend_xg_spanish_vertical.png": 39949,
	"./legend_xg_vertical.png": 64750,
	"./logo_powered.png": 49960,
	"./logo_powered_horizontal.png": 39137,
	"./pitch_black.png": 83276,
	"./pitch_black_HQ.png": 12048,
	"./pitch_black_old.png": 91354,
	"./pitch_black_wide.png": 69768,
	"./pitch_blue.png": 70277,
	"./pitch_blue_HQ.png": 62527,
	"./pitch_blue_old.png": 23059,
	"./pitch_blue_vertical.png": 83520,
	"./pitch_blue_wide.png": 24395,
	"./pitch_green.png": 60380,
	"./pitch_green_HQ.png": 7328,
	"./pitch_green_old.png": 57610,
	"./pitch_green_vertical.png": 37375,
	"./pitch_green_wide.png": 62008,
	"./pitch_grey.png": 89900,
	"./pitch_grey_wide.png": 88584,
	"./pitch_white.png": 47222,
	"./pitch_white_old.png": 60036,
	"./pitch_white_wide.png": 50686,
	"./slides/1.png": 89298,
	"./slides/2.png": 38089,
	"./slides/3.png": 83264,
	"./slides/4.png": 41919,
	"./slides/5.png": 63830,
	"./squad_template_black.png": 2907,
	"./squad_template_blue.png": 89328,
	"./squad_template_green.png": 42323,
	"./squad_template_grey.png": 485,
	"./squad_template_white.png": 62373,
	"./t3n-logo.png": 2373,
	"./twitter.png": 87087,
	"./visualization_lollipop.png": 95358,
	"./visualization_polar.png": 48711,
	"./visualization_radar.png": 90815
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92183;